export default class SpecificsService {
  static getSpecifics() {
    return [
      { id: "01", name: "Ассистенс, операционная деятельность", icon: "/specifics/01.png", eng_name: "Operation assistant" },
      { id: "02", name: "Без опыта, стажировки, временно", icon: "/specifics/02.png", eng_name: "No experience, training" },
      { id: "03", name: "Блокчейн, криптовалюты", icon: "/specifics/03.png", eng_name: "Crypto, blockchains" },
      { id: "04", name: "Дизайн", icon: "/specifics/04.png", eng_name: "Design" },
      { id: "05", name: "Информационные технологии", icon: "/specifics/05.png", eng_name: "Information technologies" },
      { id: "06", name: "Искусство", icon: "/specifics/06.png", eng_name: "Art" },
      { id: "07", name: "Киберспорт", icon: "/specifics/07.png", eng_name: "Cybersport" },
      { id: "08", name: "Маркетинг, реклама и PR", icon: "/specifics/08.png", eng_name: "Marketing, PR, advertising" },
      { id: "09", name: "Медиа, развлечения", icon: "/specifics/09.png", eng_name: "Media, entertainments" },
      { id: "10", name: "Наука, Образование", icon: "/specifics/10.png", eng_name: "Science and education" },
      { id: "11", name: "Красота и здоровье", icon: "/specifics/11.png", eng_name: "Beauty & health" },
      { id: "12", name: "Мода", icon: "/specifics/12.png", eng_name: "Fashion" },
      { id: "13", name: "Хорека", icon: "/specifics/13.png", eng_name: "Horeca" },
      { id: "14", name: "Геймдев", icon: "/specifics/14.png", eng_name: "Game dev" }
    ];
  }
}